import { PropsWithChildren } from "react";
import { Element } from "react-scroll";
import ProductIndicator from "./ProductIndicator";
import StepIndicator from "./StepIndicator";
import Header from "./Header";
import { Footer } from "./Footer";
import CookieConsent from "react-cookie-consent";


const Layout: React.FC<PropsWithChildren> = (props) => {
  return (
    <>
      <div className="bg-green-800 min-h-screen flex flex-col">
        <div className="bg-gray-50 px-10 py-6 border-b border-gray-300">
          <div className="flex justify-between">
            <a href="/">
              <img
                src="/images/bilhandel.svg"
                className="h-6"
                alt="bilhandel billån"
              />
            </a>
            <span className="text-xs text-gray-900">
              <span className="hidden sm:inline-block">
                Finansieringen tilbydes af
              </span>
              <img
                alt="resursbank"
                src="/images/resurs-logo-blue.svg"
                className="ml-4 h-6 inline-block"
              />
            </span>
          </div>
        </div>
        <div
          className="flex-grow pb-20 px-2 "
          style={{ backgroundColor: "#E0EFF2" }}
        >
          <div>
            <Header />
            <Element name="top-of-content"></Element>
            <div
              className="px-2 py-4 sm:px-5 sm:py-7 md:max-w-2xl md:mx-auto border-white rounded mt-12 shadow-md"
              style={{ backgroundColor: "#F3FAFA" }}
            >
              <>
                <ProductIndicator />
                <StepIndicator />
                {props.children}
              </>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <CookieConsent
        buttonText="Ok"
        buttonStyle={{
          backgroundColor: "#29A094",
          color: "#fff",
          borderRadius: "5px",
          width: "100px",
        }}
        contentStyle={{ margin: "0px" }}
      >
        <div className="text-xs text-left ml-4 mt-2  sm:text-right">
          Denne hjemmeside benytter cookies,{" "}
          <a href="/privatlivspolitik" className="underline">
            læs mere
          </a>
        </div>
      </CookieConsent>
    </>
  );
};

export default Layout;
